/**
 * SQL predicate: the photo aliased `alias` belongs to a project. Photos are
 * linked to projects through observation_photos→observations,
 * survey_site_photos→survey_sites and geospatial_data_photos→geospatial_data.
 *
 * Geospatial photos are also matched through the local-only association
 * table: a record that hasn't been uploaded yet still holds the only copy of
 * its photos, and leaving them out of the watch set would let the queue
 * archive them (and evict the bytes) before they ever reached the server.
 *
 * Bind {@link projectPhotoParameters} for its placeholders.
 */
export function projectPhotoCondition(alias: string): string {
  return `(
    ${alias}.id IN (
      SELECT op.photo_id FROM observation_photos op
      JOIN observations o ON o.id = op.observation_id
      WHERE o.project_id = ?
    )
    OR ${alias}.id IN (
      SELECT ssp.photo_id FROM survey_site_photos ssp
      JOIN survey_sites ss ON ss.id = ssp.survey_site_id
      WHERE ss.project_id = ?
    )
    OR ${alias}.id IN (
      SELECT gdp.photo_id FROM geospatial_data_photos gdp
      WHERE gdp.project_id = ?
    )
    OR ${alias}.id IN (
      SELECT lgdp.photo_id FROM local_geospatial_data_photos lgdp
      WHERE lgdp.project_id = ?
    )
  )`
}

export function projectPhotoParameters(projectId: string): string[] {
  return [projectId, projectId, projectId, projectId]
}
